import Container from 'react-bootstrap/Container'
import Image from 'react-bootstrap/Image'
import StarIcon from '../../../assets/icons/common/star.svg'
import PersonIcon from '../../../assets/icons/common/person.svg'
import './style.scss'

const BestSaleSlider = ({ data = [] }) => {
  const topSeller = data[0] || {}
  const rows = data.length > 0 ? data : []

  const fullName = (item = {}) =>
    `${item.firstname || ''} ${item.lastname || ''}`.trim() || 'AGC Member'

  return (
    <section className='ag-top-sales'>
      <Container>
        <div className='ag-top-sales__header'>
          <div>
            <span className='ag-top-sales__eyebrow'>Sales leaders</span>
            <h2>Top Sales Achievements</h2>
            <p>
              Recognizing members whose product movement and repeat effort help
              the Actual Green network grow stronger.
            </p>
          </div>

          <div className='ag-top-sales__featured'>
            <div className='ag-top-sales__featured-image'>
              <Image
                src={topSeller.user_image || PersonIcon}
                alt={fullName(topSeller)}
              />
            </div>
            <div>
              <span>Current highlight</span>
              <strong>{fullName(topSeller)}</strong>
              <p>{topSeller.order_amount || 0} TK in sales</p>
            </div>
          </div>
        </div>
      </Container>

      <div className='ag-top-sales__rail' aria-label='Top sales members'>
        {[0, 1].map((group) => (
          <div
            aria-hidden={group === 1}
            className='ag-top-sales__group'
            key={group}
          >
            {rows.map((item, i) => (
              <article className='ag-top-sales__card' key={`${group}-${item.id || i}`}>
                <Image
                  className='ag-top-sales__avatar'
                  src={item.user_image || PersonIcon}
                  alt={fullName(item)}
                />
                <div className='ag-top-sales__rank'>
                  <Image src={StarIcon} alt='' />
                  <span>#{i + 1}</span>
                </div>
                <div className='ag-top-sales__body'>
                  <h3>{fullName(item)}</h3>
                  <strong>{item.order_amount || 0} TK</strong>
                </div>
              </article>
            ))}
          </div>
        ))}
      </div>
    </section>
  )
}

export default BestSaleSlider
